define(function (require) {
    "use strict";

	var LE = require("app");
    var Page = require("ui.components/page/Page");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var OrganizeCollectionDecorator = require ("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");
    var AgentGroupsMoveGridModel = require("user-management-models/AgentGroupsMoveGridModel");
    var AgentGroupMoveLayout = require("user-management-views/agent-groups/AgentGroupMoveLayout");
    var AgentGroupMoveGridView = require("user-management-views/agent-groups/AgentGroupMoveGridView");
    var AgentGroupMoveFilters = require("user-management-filters/AgentGroupMoveFilters");
    var AgentGroupListComparators = require("user-management-comparators/AgentGroupListComparators");
    var AgentGroupUtilities = require("user-management-utils/AgentGroupUtilities");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var SecureUtilities = require("infra-util/SecureUtilities");

    var NAME_COMPARATOR = "name";
    var ASC_ORDERBY = "asc";
    var DEFAULT_COMPARATOR = NAME_COMPARATOR;
    var DEFAULT_ORDERBY = ASC_ORDERBY;
    var PAGE_SIZE = 25;

    var USER_GROUPS = {
        MANAGER_OF: "managerOf",
        MEMBER_OF: "memberOf"
    };
    var USERMODEL_ATTRIBUTES = {
        FULL_NAME: "fullName"
    };
    var USER_ROLE = {
        MANAGERS: "managers",
        MEMBERS: "members"
    };

    var AgentGroupMoveController = {};

    LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupMoveController = Marionette.Controller.extend({
            currentPagingInfo: {
                currentPageNumber: 1,
                totalPages: 1
            },
            currentComparator: DEFAULT_COMPARATOR,
            currentOrderBy: DEFAULT_ORDERBY,
            currentSelectedId: null,
            currentFilter: {},

            initialize: function (options) {
                this._initialize(options);
            },

            _initialize: function () {
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.AGENT_GROUP_MOVE);
                this._bindEventsChannel();
            },

            _bindEventsChannel: function() {
                this.listenTo(this.channel.vent, "agentGroupMoveLayout:buttons:moveGroup", this._onMoveGroup);
                this.listenTo(this.channel.vent, "paging:change", this._onPagingChange);
                this.listenTo(this.channel.vent, "row:selector:click", this._onRowSelectorClick);
                this.listenTo(this.channel.vent, "page:close", this._onClose);
            },

            getView: function (options) {
                return this._getView(options);
            },

            _getView: function(options) {
                this._unbindEventsDataAndViews();
                this._initData(options);
                this._initViews();
                this._bindEventsDataAndViews();
                return this._getMainView();
            },

            _getMainView: function(){
                var moveModel = this.agentGroupsCollection.get(this.agentGroupId);
                var message = LE.translator.translate({
                    key: "LEUserManagement.agentGroupList.move.agent.group.text",
                    args: [{key: SecureUtilities.escapeForHtmlContent(this.moveModel.getName()), isTranslate:false}]
                });
                this.mainView = new Page({
                    moduleName:LEUserManagement.moduleName,
                    context:LE.context,
                    isPermanent: true,
                    view:        this.agentGroupMoveLayout,
                    header: {
                        title: LE.translator.translate("LEUserManagement.agentGroupList.move.agent.group.title"),
                        description: message
                    }
                });
                return this.mainView;
            },

            _initData: function(options) {
                this.agentGroupId = options.agentGroupId;
                this.agentGroupsGridModel = new AgentGroupsMoveGridModel({},{agentGroupId: this.agentGroupId});
                this.usersCollection = LEUserManagement.getDataManager().getUsersCollection();
                var agentGroupsCollection = LEUserManagement.getDataManager().getAgentGroupsCollection();
                agentGroupsCollection = agentGroupsCollection.clone();
                this.moveModel = agentGroupsCollection.get(options.agentGroupId);
                var id = this.moveModel.get("id");
                AgentGroupUtilities.removeTreeAgentGroupSelected(agentGroupsCollection, id);
                agentGroupsCollection = SelectableCollectionDecorator.decorate(agentGroupsCollection, this.currentSelectedId);
                this.agentGroupsCollection = OrganizeCollectionDecorator.decorate(agentGroupsCollection, {
                    comparator: this.currentComparator,
                    orderBy: this.currentOrderBy,
                    currentPage: this.currentPagingInfo.currentPageNumber,
                    pageSize: PAGE_SIZE,
                    lazy: true
                });
            },

            _initViews: function() {
                this.agentGroupMoveLayout = new AgentGroupMoveLayout({
                    collection: this.agentGroupsCollection
                });
                this.agentGroupMoveGridView = new AgentGroupMoveGridView({
                    collection:this.agentGroupsCollection,
                    model: this.agentGroupsGridModel,
                    filters: AgentGroupMoveFilters,
                    comparators: AgentGroupListComparators
                });
            },

            _bindEventsDataAndViews: function() {
                this.listenTo(this.agentGroupMoveLayout, "render", this._onLayoutRender);
                this.listenTo(this.agentGroupMoveLayout, "close", this._onLayoutClose);
                this.listenTo(this.agentGroupsCollection ,"reset", this._onCollectionReset);
            },

            _onPagingChange: function(currentPageNumber) {
                LEUserManagement.logger.debug("_onPagingChange", "AgentGroupMoveController:_onPagingChange");
                this.agentGroupsCollection.organize({currentPage:currentPageNumber});
            },

            _onRowSelectorClick: function(options) {
                var itemModel = options.itemModel;
                var isChecked = options.isChecked;

                if (isChecked) {
                    var currentSelectedModel = this.agentGroupsCollection.getSelectedModel();
                    if (!_.isEmpty(currentSelectedModel)) {
                        currentSelectedModel.trigger("model:selection:change", false);
                    }
                    this.currentSelectedId = itemModel.id;
                    this.agentGroupsCollection.addToSelection(itemModel, {exclusively:true});
                    itemModel.trigger("model:selection:change", true);
                }
                else {
                    this.channel.trigger("deselectModel",{model:itemModel});
                    itemModel.trigger("model:selection:change", false);
                }
                this.channel.trigger("agentGroupMove:rowSelectorClick",{isChecked:isChecked});
            },

            _openLoader:function () {
                this.mainView.showLoader();
            },

            _closeLoader: function(){
                this.mainView.closeLoader();
            },

            _selectItem: function (options) {
                if (options.select) {
                    this.model.getCollection().addToSelection(options.model, {exclusively: true});
                } else {
                    this.model.getCollection().deselectModel(options.model);
                }

            },
            _pageChange: function (currentPageNumber) {
                this.model.pageNumberChange(currentPageNumber);
            },

            _onLayoutRender: function() {
                _.each(this.currentFilter, _.bind(function(filterValues, filterName){
                    this.agentGroupsGridModel.setFilterValue(filterName, filterValues);
                }, this));

                this._deselectModel();

                this.agentGroupsCollection.organize({filterModel:this.agentGroupsGridModel});
                this.agentGroupMoveLayout.gridRegion.show(this.agentGroupMoveGridView);
            },

            _onCollectionReset: function(collection, options) {
                //set correct comparator
                if (_.has(options, "comparator")) {
                    this.currentComparator = options.comparator;
                }

                // set correct order by
                if (_.has(options, "orderBy")) {
                    this.currentOrderBy = options.orderBy;
                }

                if (_.has(options, "filterModel")) {
                    _.each(AgentGroupsMoveGridModel.FILTER_ENUM, _.bind(function(filterName) {
                        this.currentFilter[filterName] = options.filterModel.get("filters."+filterName);
                    }, this));
                }
            },

            _onMoveGroup: function() {
                var selectedModel = this.agentGroupsCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel) && !_.isEmpty(this.moveModel)) {
                    var oldParentGroupId = this.moveModel.get("parentGroupId");
                    var oldParentGroupModel = this.agentGroupsCollection.getOriginalCollection().get(oldParentGroupId);
                    var newParentGroupId = selectedModel.get("id");
                    var newParentGroupModel = this.agentGroupsCollection.get(newParentGroupId);

                    var message = LE.translator.translate({
                        key: "LEUserManagement.agentGroupList.move.agent.group.warning.message",
                        args: [{key: SecureUtilities.escapeForHtmlContent(this.moveModel.getName()), isTranslate:false}, {key: SecureUtilities.escapeForHtmlContent(this.moveModel.getName()), isTranslate:false}, {key: SecureUtilities.escapeForHtmlContent(oldParentGroupModel.getName()), isTranslate:false}, {key: SecureUtilities.escapeForHtmlContent(newParentGroupModel.getName()), isTranslate:false}]
                    });

                    LEUserManagement.notifier.showConfirm({
                        title: LE.translator.translate("LEUserManagement.agentGroupList.move.agent.group.title"),
                        content: message,
                        objectAction: {
                            text: LE.translator.translate("LEFramework.global.captions.move"),
                            callback: _.bind(this._onMove, this)
                        }
                    });
                }
            },

            _onMove: function() {
                var selectedModel = this.agentGroupsCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    this._openLoader();
                    this.moveModel.set("parentGroupId", selectedModel.get("id"));
                    this.moveModel.save(null, {
                        success: _.bind(this._onSaveClose, this),
                        error: _.bind(this._onSaveError, this)
                    });
                }
            },

            _onSaveClose: function() {
                this._onClose();
                this._closeLoader();
                LEUserManagement.vent.trigger("agentGroupList:resetList");
            },

            _onSaveError: function(model, resp, options) {
                this._closeLoader();
                var generalErrorMessage = LE.translator.translate({
                    key: "LEUserManagement.agentGroupList.move.error.try.move.again",
                    args: [{key: model.getName(), isTranslate:false}]
                });
                if (resp && resp.responseError) {
                    if (resp.responseError.internalCode === ErrorCodes.concurrentModificationConflict) {
                        generalErrorMessage = LE.translator.translate("LEUserManagement.agentGroupList.move.error.complete.move.process");
                    }
                }
                LEUserManagement.notifier.showError({"content":generalErrorMessage,"timeToShow":8000});
            },

            _deselectModel: function(options) {
                var selectedModel;
                if (options) {
                    selectedModel = options.model;
                } else if (this.agentGroupsCollection) {
                    selectedModel = this.agentGroupsCollection.getSelectedModel();
                }
                this.currentSelectedId = null;
                if (selectedModel) {//In case the user edited an agent group without checking it
                    this.agentGroupsCollection.deselectModel(selectedModel, {silent:true});
                    selectedModel.trigger("model:selection:change", false);
                }
            },

            _onLayoutClose: function() {
                this._unbindEventsDataAndViews();
            },

            _unbindEventsDataAndViews: function() {
                if (this.agentGroupMoveLayout) {
                    this.stopListening(this.agentGroupMoveLayout);
                }
                if (this.agentGroupsCollection) {
                    this.stopListening(this.agentGroupsCollection);
                }
            },

            _close: function(){
                this._onClose();
            },

            _onClose: function () {
                this.channel.vent.stopListening();
                this._onLayoutClose();
                this.mainView.close();
                LEUserManagement.router.navigate("agentGroups");
            }
        });
    });

    return  AgentGroupMoveController;
});
